<template>
  <v-checkbox v-model="form.send_failure_notifications"
              label="Notify me of email bounces"
              dense
              hint="Receive immediate notifications for each bounced email. If unchecked, you can still view all delivery statuses in your campaign report. Enable for time-sensitive campaigns or when immediate action on failed deliveries is needed."
              persistent-hint
              class="mt-0 pt-0">
  </v-checkbox>
</template>
<script>
// Claude helped me write the hint.
// @see https://claude.ai/chat/e10077db-c355-4b92-ae5a-ede6836c2dc7
export default {
  props: {
    form: {
      type: Object,
      required: true,
    }
  }
}
</script>
